import axios from "axios";
import { store } from "./store";
import config from "./config";
import * as auth from "./msal";

export function getReqConfig(token, provider, tenant, additionalHeaders) {
	let headers = {};

	if (provider) {
		headers["auth-provider"] = provider;
	}
	if (token) {
		headers["Authorization"] = `Bearer ${token}`;
	}
	if (tenant) {
		headers["tenant-id"] = tenant;
	}

	let config = {
		headers: headers,
	};
	if (additionalHeaders != null) {
		config.headers = { ...additionalHeaders, ...config.headers };
	}

	return config;
}

export function getNewToken() {
	let refreshToken = localStorage.getItem("refreshToken");
	return axios.post(
		`${config.apiUrl}/identity/refresh`,
		{
			refreshToken: refreshToken,
		},
		getReqConfig(undefined, undefined, store.getters.getTenantId)
	);
}

export function msalAuth(msal, auth, tokenResponse) {
	if (msal.isAuthenticated()) {
		let stored = false;
		let token = store.getters.getToken;

		//Store or refresh token
		if (msal.data.idToken && token !== msal.data.idToken) {
			store.dispatch("setToken", msal.data.idToken);
			stored = true;
		} else if (
			tokenResponse &&
			tokenResponse.idToken &&
			tokenResponse.idToken.rawIdToken &&
			token !== tokenResponse.idToken.rawIdToken
		) {
			store.dispatch("setToken", tokenResponse.idToken.rawIdToken);
			stored = true;
		}

		//Call api to get permissions and such on first time, missing, or refresh
		let user = store.getters.getUser;
		if (
			stored ||
			user == null ||
			msal.data.user.userName.toLowerCase() !== user.email.toLowerCase()
		) {
			axios
				.get(
					`${config.apiUrl}/users/${msal.data.user.userName}/permissions`,
					auth.getReqConfig(msal.data.idToken, "Microsoft")
				)
				.then((response) => {
					store.dispatch("setUser", response.data.userAccount);
					store.dispatch("setAuthenticated", true);
					store.dispatch("setAuthProvider", "Microsoft");
					store.dispatch("setAuthError", "");
				})
				.catch((err) => {
					store.dispatch("setToken", "");
					if (
						err.response.data[0] ===
						"You have been removed from DashTech project. Please log out."
					) {
						if (
							msal != null &&
							msal.data != null &&
							msal.data.user != null &&
							msal.data.user.userName
						) {
							store.dispatch(
								"setAuthError",
								`No user with email '${msal.data.user.userName}' exists. ` +
									"Please make sure you have been invited to a project and that you are using the email you were added to the project with. " +
									"Contact your project manager if you would like your email changed."
							);
						} else {
							store.dispatch(
								"setAuthError",
								"User does not exist. Please make sure you have been invited to a project and that you are using the email you were added to the project with. " +
									"Contact your project manager if you would like your email changed."
							);
						}
					} else {
						store.dispatch("setAuthError", err.response.data[0]);
					}
					msal.signOut();
				});
		}
	}
}

export async function setupAuth(tokenResponse) {
	let token = tokenResponse.idToken;
	if (token) {
		store.dispatch("setToken", token);
		store.dispatch("setTokenExpiration", tokenResponse.expiresOn);
	} else {
		throw "idToken missing";
	}

	// console.log("token response", tokenResponse);

	let username = tokenResponse.account.username;
	let name = tokenResponse.account.name;
	let preferred = tokenResponse.account.idTokenClaims.preferred_username;
	auth.msal.setActiveAccount(tokenResponse.account);
	let setupUser = async (response) => {
		let projectId = localStorage.getItem('tempProjectId')

		if (projectId) {
			let userId = response.data.userAccount.userId
			let userEmail = response.data.userAccount.email
			let url = `${config.apiUrl}/users/${userEmail}/permissions`

			await axios
				.get(url, getReqConfig(token, "Microsoft"))
				.then(res => {
					let permissions = res.data.userAccount.projectPermissions
					let project = permissions.find(p => p.id == projectId)

					if (!project){
						window.location.href = `${window.location.origin}/account/setup?uid=${userId}`
					}
				})
		}

		let actions = [
			store.dispatch("setUser", response.data.userAccount),
			store.dispatch("setAuthenticated", true),
			store.dispatch("setAuthProvider", "Microsoft"),
			store.dispatch("setAuthError", ""),
		];
		if (response.data.tenantId) {
			actions.push(store.dispatch("setTenantId", response.data.tenantId));
		}
		return await Promise.all(actions);
	};

	let authAttempt = axios
		.get(
			`${config.apiUrl}/users/${username}/permissions`,
			getReqConfig(token, "Microsoft")
		)
		.catch(async (err) => {
			if (err.response.status === 404) {
				return axios.get(
					`${config.apiUrl}/users/${preferred}/permissions`,
					getReqConfig(token, "Microsoft")
				);
			} else if (
				localStorage.getItem("tempProjectId") &&
				err.response.status === 401
			) {
				let url = `${config.apiUrl}/users/register-account`;
				let request = {
					userId: localStorage.getItem("tempUserId"),
					projectId: localStorage.getItem("tempProjectId"),
					hasMicrosoft: true,
					name: name,
					email: username,
				};

				// console.log(request);

				await axios.post(url, request, getReqConfig()).then(() => {
					localStorage.removeItem("tempUserId");
				});
				return axios.get(
					`${config.apiUrl}/users/${preferred}/permissions`,
					getReqConfig(token, "Microsoft")
				);
			} else {
				store.dispatch("setAuthError", err.response.data[0]);
				return err;
			}
		});

	await authAttempt.then(setupUser).catch(async (err) => {
		// console.log("error in await auth attempt", err);
		let error;
		if (err.response) {
			if (err.response.status === 404) {
				error =
					`No user with email '${username}' exists. ` +
					"Please make sure you have been invited to a project and that you are using the email you were added to the project with. " +
					"Contact your project manager if you would like your email changed.";
			} else {
				error = err.response.data[0];
			}
			await store.dispatch("setAuthError", error);
			await clearSession();
		}
	});
}

export async function clearSession() {
	localStorage.removeItem("refreshToken");

	//LEGACY - remove a few months from now
	localStorage.removeItem("expirationTime");
	localStorage.removeItem("expireTime");
	localStorage.removeItem("userId");
	localStorage.removeItem("userName");
	localStorage.removeItem("sponsor");
	localStorage.removeItem("admin");
	localStorage.removeItem("participant");
	localStorage.removeItem("permissions");

	return store.dispatch("clearSession");
}
